// Copyright (c) 2016 Deere & Company

import {routerActions} from 'react-router-redux';

export const goToPreviousView = () =>
    routerActions.goBack();



// WEBPACK FOOTER //
// ./src/product/shared/action-creators/go-to-previous-view.js